/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { VisitorMapAndHoursCreateInput } from './visitorMapAndHoursCreateInput';


export interface Model57 extends Array<VisitorMapAndHoursCreateInput> { 
}
